/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @param {IconSize} [props.iconSize]
 * @returns {React.ReactElement} The rendered component
 */
const Chevron = ({ className, iconSize }) => {
  if (iconSize === 'md') {
    return (
      <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.46839 6.969C2.53806 6.89915 2.62082 6.84374 2.71194 6.80593C2.80305 6.76812 2.90074 6.74866 2.99939 6.74866C3.09804 6.74866 3.19572 6.76812 3.28684 6.80593C3.37796 6.84374 3.46072 6.89915 3.53039 6.969L11.9994 15.4395L20.4684 6.969C20.5381 6.89927 20.6209 6.84395 20.712 6.80621C20.8031 6.76847 20.9008 6.74905 20.9994 6.74905C21.098 6.74905 21.1957 6.76847 21.2868 6.80621C21.3779 6.84395 21.4607 6.89927 21.5304 6.969C21.6001 7.03873 21.6554 7.12151 21.6932 7.21262C21.7309 7.30373 21.7503 7.40138 21.7503 7.5C21.7503 7.59861 21.7309 7.69626 21.6932 7.78737C21.6554 7.87848 21.6001 7.96127 21.5304 8.031L12.5304 17.031C12.4607 17.1008 12.378 17.1563 12.2868 17.1941C12.1957 17.2319 12.098 17.2513 11.9994 17.2513C11.9007 17.2513 11.8031 17.2319 11.7119 17.1941C11.6208 17.1563 11.5381 17.1008 11.4684 17.031L2.46839 8.031C2.39854 7.96133 2.34313 7.87857 2.30532 7.78745C2.26751 7.69633 2.24805 7.59865 2.24805 7.5C2.24805 7.40135 2.26751 7.30366 2.30532 7.21255C2.34313 7.12143 2.39854 7.03867 2.46839 6.969Z"
          fill="#002967"
        />
      </svg>
    );
  }

  if (iconSize === 'sm') {
    return (
      <svg
        className={className}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.6922 5.26186L8.73801 12.2161C8.6411 12.3133 8.52595 12.3905 8.39915 12.4431C8.27236 12.4958 8.13642 12.5229 7.99913 12.5229C7.86184 12.5229 7.7259 12.4958 7.59911 12.4431C7.47231 12.3905 7.35716 12.3133 7.26025 12.2161L0.306055 5.26186C0.110092 5.0659 -2.92009e-09 4.80012 0 4.52298C2.92009e-09 4.24585 0.110092 3.98006 0.306055 3.7841C0.502019 3.58813 0.767803 3.47804 1.04494 3.47804C1.32207 3.47804 1.58786 3.58813 1.78382 3.7841L8 10.0003L14.2162 3.78323C14.4121 3.58726 14.6779 3.47717 14.9551 3.47717C15.2322 3.47717 15.498 3.58726 15.6939 3.78323C15.8899 3.97919 16 4.24498 16 4.52211C16 4.79925 15.8899 5.06503 15.6939 5.26099L15.6922 5.26186Z"
          fill="#002967"
        />
      </svg>
    );
  }

  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7692 5.94643L8.55351 11.1621C8.48083 11.235 8.39446 11.2929 8.29937 11.3324C8.20427 11.3719 8.10231 11.3922 7.99935 11.3922C7.89638 11.3922 7.79442 11.3719 7.69933 11.3324C7.60423 11.2929 7.51787 11.235 7.44519 11.1621L2.22954 5.94643C2.08257 5.79945 2 5.60012 2 5.39227C2 5.18441 2.08257 4.98508 2.22954 4.8381C2.37651 4.69113 2.57585 4.60856 2.7837 4.60856C2.99155 4.60856 3.19089 4.69113 3.33787 4.8381L8 9.50024L12.6621 4.83745C12.8091 4.69048 13.0084 4.60791 13.2163 4.60791C13.4241 4.60791 13.6235 4.69048 13.7705 4.83745C13.9174 4.98442 14 5.18376 14 5.39161C14 5.59947 13.9174 5.7988 13.7705 5.94578L13.7692 5.94643Z"
        fill="#002967"
      />
    </svg>
  );
};

export default Chevron;
